import fedshiMark from '../../assets/fedshi-mark.png';

// Square Fedshi mark for the collapsed sidebar.
const LogoIcon = () => {
  return <img src={fedshiMark} alt="Fedshi" style={{ height: 28, width: 'auto' }} />;
};

export default LogoIcon;
